module.exports = __webpack_public_path__ + "img/scene-snow.33cc9599.png";